import { render, staticRenderFns } from "./TxEvents.vue?vue&type=template&id=109c6041"
import script from "./TxEvents.vue?vue&type=script&lang=js"
export * from "./TxEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports